export default {
  reports: {
    // ---- AI report error codes (backend `errorCode`) -> localized messages ----
    errors: {
      INSUFFICIENT_CREDITS:
        "U heeft niet genoeg AI-credits om dit rapport te genereren. Neem contact op met uw beheerder.",
      REPORT_ACCESS_DENIED: "Dit AI-rapport is niet ingeschakeld voor uw account.",
      NOT_FOUND: "Het gevraagde rapport kon niet worden gevonden.",
      INVALID_INPUT: "Sommige opgegeven gegevens zijn ongeldig. Controleer ze en probeer het opnieuw.",
      INVALID_GEOMETRY: "Het geselecteerde gebied is niet geldig. Pas de geofence aan en probeer het opnieuw.",
    },
    gen: "Geslacht",
    total: "Totaal",
    gender: "Geslachtstabel",
    male: "Mannelijk",
    female: "Vrouwelijk",
    other: "Anders",
    byCountry: "Per land",
    avgPriceFarmer: "Gemiddelde prijs betaald aan boer (Cacao)",
    avgPrice: "Gemiddelde prijs",
    selectYear: "Selecteer jaar",
    farmerName: "Naam van de boer",
    farmerProdChart: "Grafiek van boerenproductie",
    production: "Productie",
    byProduction: "Per productie",
    byName: "Per naam",
    descending: "Aflopend",
    ascending: "Oplopend",
    buyingStationProdChart: "Grafiek van productie van inkoopstation",
    buyingStation: "Inkoopstation",
    buyingStationName: "Naam van inkoopstation",
    dryMilling: "Droge maling",
    dryMillingName: "Naam van droge maling",
    dryMillingProdChart: "Grafiek van productie van droge maling",
    view: "Weergave",
    date: "Datum",
    reports: "Rapporten",
    today: "Vandaag",
    week: "Week",
    month: "Maand",
    year: "Jaar",
    all: "Alles",
    selectCrop: "Selecteer Gewas",
    selectRegion: "Selecteer Regio",
    selectProvinceState: "Selecteer Provincie/Status",
    downloadPdfReport: "Downloaden PDF-rapport",
    export: "Exporteer",
    search: "Zoeken",
    yield: "Opbrengst",
    averageSellingPriceByAllFarmers: "Gemiddelde verkoopprijs door alle boeren",
    averageSellingPricePerFarmer: "Gemiddelde verkoopprijs per boer",
    pricePaid: "Betaalde prijs",
    pests: {
      pestReport: "Plaagrapport",
      filterByCrops: "Filteren op gewassen",
      pestStatistics: "Plaagstatistieken",
      regions: "Regio's",
      occurrences: "Voorvallen",
      pestChart: "Plaaggrafiek",
      totalArea: "Totale oppervlakte",
      pestName: "Naam van de plaag",
      region: "Regio",
      crop: "Gewassen",
      listByLand: "Lijst per land",
    },
    regions: {
      regionalReport: "Regionaal rapport",
      listByFarm: "Lijst per boerderij",
      listByFarmers: "Lijst per boeren",
      listByYield: "Lijst per opbrengst",
      regionalStatistics: "Regionale statistieken",
      countries: "Landen",
      states: "Staten/Provincies",
      city: "Stad/Dorp",
      farmsIn: "Boerderijen in",
      regionalChart: "Regionale grafiek",
      farms: "Boerderijen",
      regionName: "Naam van de regio",
      farmers: "Boeren",
      yield: "Opbrengst/Acre",
    },
    dashboard: {
      topCharts: "Topgrafieken",
      regions: "Regio's",
      noOfFarms: "Aantal Boerderijen/Gebieden",
      provinces: "Provincies",
      landArea: "Landoppervlakte",
      avgFarmerLand: "Gemiddeld Boerenland",
      viewAll: "Bekijk Alles",
      crops: "Gewassen",
      plantedAreaCrop: "Gepland Gebied/Gewas",
      plantedArea: "Gepland Gebied",
      avgYieldCrop: "Gemiddelde Opbrengst/Gewas",
      averageYield: "Gemiddelde Opbrengst",
      yieldChart: "Opbrengstgrafiek",
      selectFarm: "Selecteer Boerderij",
      soilQuality: "Grondkwaliteit",
      pests: "Ongedierte",
      occurrences: "Voorvallen",
      equipments: "Apparatuur",
      goalAchievedChart: "Grafiek van Bereikte Doelen",
      soilValues: "Grondwaarden",
      soil: "Grond",
      showReport: "Toon Rapport op Dashboard",
      selectAll: "Selecteer Alles",
    },

    yieldPrediction: "Opbrengstvoorspelling",
    listOfReports: "Lijst van Rapporten",
    noYieldPredictionReportsFound: "Geen opbrengstvoorspellingsrapporten gevonden",
    loadingYieldPredictions: "Opbrengstvoorspellingen laden...",
    createNewReport: "Nieuw Rapport Maken",

    howToUseReport: "Hoe het rapport te gebruiken?",
    viewGuide: "Gids bekijken",
    cancel: "Annuleren",
    generateReport: "Rapport Genereren",
    selectFarmGeofence: "Selecteer Boerderij Geofence",
    selectFarmGeofenceDescription: "Selecteer een geregistreerde boerderij, teken uw boerderijgrens op de kaart of voer een locatie in om de opbrengstvoorspelling van uw boerderijgebied te analyseren.",
    point: "Punt",
    geofence: "Geofence",
    selectFarmZone: "Selecteer Boerderij/Zone",
    select: "Selecteer",
    latitude: "Breedtegraad",
    longitude: "Lengtegraad",
    uploadGeojsonFile: "GeoJSON-bestand Uploaden",
    uploadGeojsonFileDescription: "Selecteer een GeoJSON-bestand met uw geofence van uw computer en upload het. Er wordt slechts één geofence tegelijk geüpload, zelfs als uw bestand meerdere geofences bevat.",
    selectAFile: "Selecteer Een Bestand",
    hideAdvanced: "Geavanceerd Verbergen",
    showAdvancedVariation: "Geavanceerde Variatie Tonen",
    uploadHistoricalYieldDataDescription: "Upload de historische opbrengstgegevens van uw boerderij",
    showInstructions: "Instructies Tonen",
    downloadTemplate: "Sjabloon Downloaden",
    chooseFile: "Bestand Kiezen",
    noFileSelected: "Geen bestand geselecteerd",
    yieldPredictionGuide: "Gids voor Opbrengstvoorspelling",
    forecastedYields: "Voorspelde Opbrengsten",
    farmArea: "Boerderijgebied",
    yieldForecasts: "Opbrengstvoorspellingen",
    graph: "Grafiek",
    actualYields: "Werkelijke Opbrengsten",
    predictedFutureYields: "Voorspelde Toekomstige Opbrengsten",
    averageYields: "Gemiddelde Opbrengsten",
    yieldTrendsGraph: "Opbrengsttrends Grafiek",
    step1: "Stap 1",
    step2: "Stap 2",
    step3: "Stap 3",
    step4: "Stap 4",
    satelliteMapView: "Satellietkaartweergave",
    selectYourFarm: "Selecteer uw boerderij in het vervolgkeuzemenu (indien al geregistreerd).",
    selectCropType: "Selecteer een gewastype:",
    clickGenerateReport: "Klik op 'Rapport Genereren' om uw opbrengstvoorspellingsrapport te bekijken.",
    howToGenerateReport: "Hoe een Rapport Genereren?",
    howToInterpretReport: "Hoe het Rapport Interpreteren?",
    tip: "Tip",

    disclaimer: "Disclaimer",
    disclaimer1: "Het is onmogelijk om het weer voor een heel seizoen nauwkeurig te voorspellen. Bijvoorbeeld hagel of overstromingen kunnen op elk moment optreden, wat de opbrengstvoorspellingen aanzienlijk kan beïnvloeden.",
    disclaimer2: "Opbrengsten zijn sterk afhankelijk van de beheerpraktijken van de boer. Bijvoorbeeld tijdige toepassing van pesticiden of goede irrigatie kan de uiteindelijke opbrengst aanzienlijk beïnvloeden.",
    disclaimer3: "Er zijn andere factoren die kunnen bijdragen aan significante fouten in AI-opbrengstvoorspellingen.",
    startYear: "Beginjaar",
    endYear: "Eindjaar",
    back: "Terug",
    deleteReport: "Rapport Verwijderen",
    confirmDeleteReport: "Weet u zeker dat u dit opbrengstvoorspellingsrapport wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt en alle bijbehorende gegevens worden permanent verwijderd.",
    deleteConfirmation: "Verwijderbevestiging",
    download: "Downloaden",
    report: "Rapport",
    dateOfReport: "Datum van Rapport",
    farm: "Boerderij",
    location: "Locatie",
    zone: "Zone",
    crop: "Gewas",
    farmers: "Boeren",
    yieldPerAcre: "Opbrengst/Acre",
    yieldPerHectare: "Opbrengst/Hectare",
    predictionModel: "Voorspellingsmodel",
    accuracy: "Nauwkeurigheid (R²)",
    confidence: "Vertrouwen",
    producer: "Producent",
    reportDeletedSuccessfully: "Rapport succesvol verwijderd",
    failedToDeleteReport: "Verwijderen van rapport mislukt",
    enterHere: "Voer hier in",
    hectares: "hectare",
    whatIsYieldReportTitle: "Wat is een Opbrengstvoorspellingsrapport?",
    yieldReportDescription: "Het Opbrengstvoorspellingsrapport helpt u de gewasopbrengsten voor uw boerderij te schatten met behulp van historische gegevens, satellietgegevens en AI-gebaseerde voorspellingsmodellen. Het rapport geeft u een schatting van hoeveel u in het huidige en komende jaren zou kunnen oogsten. Het rapport biedt inzicht in werkelijke opbrengsten, voorspelde toekomstige opbrengsten en gemiddelde opbrengsten, zodat u uw landbouwactiviteiten kunt optimaliseren en vooruit kunt plannen.",
    creatingYourReportEasy: "Het maken van uw rapport is eenvoudig:",
    selectYourFarmDescription: "De grens verschijnt op de kaart. Of teken handmatig de grens van uw boerderij (polygoon of een punt) op de kaart als deze nog niet geregistreerd is. U kunt ook zoeken door breedte- en lengtegraad in te typen om in te zoomen op een locatie.",
    selectCropTypeDescription: "Kies het gewas dat u wilt analyseren in het vervolgkeuzemenu.",
    clickGenerateReportDescription: "om uw opbrengstvoorspellingsrapport te bekijken.",
    interpretReportIntro: "Zodra het rapport is gegenereerd, ziet u opbrengstvoorspellingen voor het huidige en komende jaar. Een grafiek toont opbrengsttrends voor uw boerderij met drie lijnen:",
    blueLineActualYields: "Blauwe Lijn (Werkelijke Opbrengsten):",
    blueLineDescription: "Vertegenwoordigt de werkelijke oogstresultaten van eerdere seizoenen op uw boerderij. Dit helpt u trends in prestaties uit het verleden te begrijpen.",
    redLinePredictedYields: "Rode Lijn (Voorspelde Toekomstige Opbrengsten):",
    redLineDescription: "Toont op AI gebaseerde voorspellingen voor de komende opbrengsten. Het biedt een schatting van wat u kunt verwachten (hoeveel u kunt oogsten) op basis van huidige gegevens en trends.",
    brownLineAverageYields: "Bruine Lijn (Gemiddelde Opbrengsten):",
    brownLineDescription: "Geeft de gemiddelde opbrengst van alle beschikbare gegevens voor de boerderij aan. Deze lijn dient als referentie om historische en voorspelde opbrengsten te vergelijken met de algehele trend.",
    highPredictedYieldsLabel: "Hoge voorspelde opbrengsten",
    highPredictedYieldsDescription: "suggereren dat huidige praktijken effectief zijn. Behoud uw strategieën en repliceer ze in andere delen van uw boerderij.",
    lowPredictedYieldsLabel: "Lage voorspelde opbrengsten",
    lowPredictedYieldsDescription: "kunnen verbeterpunten aangeven, zoals plantschema's, bodemgezondheid, kunstmestgebruik, irrigatie, plaagbeheer, waterstress of voedingstekorten enz. Onderzoek en adresseer deze problemen vroeg om verdere opbrengstverliezen te voorkomen.",
    tipDescription: "U kunt uw rapporten opslaan, downloaden of verwijderen voor toekomstig gebruik.",
    validationError: "Validatiefout",
    pleaseSelectCrop: "Selecteer een gewas",
    pleaseEnterLatLng: "Voer breedte- en lengtegraad in of selecteer een punt op de kaart",
    pleaseDrawGeofence: "Teken een geofence op de kaart of upload een GeoJSON-bestand",
    invalidGeojsonFile: "Ongeldig GeoJSON-bestand",
    invalidGeojsonFileDescription: "Zorg ervoor dat het bestand een geldig GeoJSON-formaat heeft.",
    errorReadingFile: "Fout bij het lezen van bestand",
    failedToReadGeojson: "Kan het GeoJSON-bestand niet lezen. Probeer het opnieuw.",
    yieldReportGeneratedSuccessfully: "Opbrengstvoorspellingsrapport succesvol gegenereerd",
    failedToGenerateReport: "Genereren van rapport mislukt. Probeer het opnieuw.",
    farmAndFarmId: "Boerderij & Boerderij-ID",
    producerName: "Naam Producent",
    failedToLoadReport: "Kan opbrengstvoorspellingsrapport niet laden",
    reportDataNotLoaded: "Rapportgegevens zijn niet geladen. Wacht en probeer het opnieuw.",
    pdfGeneratedSuccessfully: "PDF succesvol gegenereerd",
    failedToGeneratePdf: "PDF genereren mislukt. Probeer het opnieuw.",
    editMap: "Kaart Bewerken",
    editMapDescription: "Kaartbewerkingsfunctionaliteit wordt hier geïmplementeerd",
    noForecastDataAvailable: "Geen voorspellingsgegevens beschikbaar",
    noGraphImageAvailable: "Geen grafiekafbeelding beschikbaar",
    // Shared AI report redesign
    landSuitability: "Land Suitability",
    aiReportGuide: "AI Report Guide",
    aiReportsDashboard: "AI-rapportendashboard",
    aiReports: "AI-rapporten",
    dashboardGuide: "Dashboard Guide",
    aiReportBuilders: "AI Report Builders",
    aiInsightsAndAnalytics: "AI Insights and Analytics",
    reportTypeDistribution: "Report Type Distribution",
    reportType: "Report Type",
    reportsGenerated: "Reports Generated",
    recentAiReports: "Recent AI Reports",
    vegetationVigorAnalysis: "Vegetation Vigor Analysis",
    farmProductivityAnalysis: "Farm Productivity Analysis",
    anomaliesDetection: "Anomalies Detection",
    diseaseDetection: "Disease Detection",
    averageVegetationHealth: "Average Vegetation Health",
    diseaseDetectedThisMonth: "Disease Detected this Month",
    anomaliesThisMonth: "Anomalies this Month",
    predictedYieldTrend: "Predicted Yield Trend",
    comingSoon: "Binnenkort",
    reportBuilderComingSoon: "This AI report builder is coming soon.",
    loadingRecentReports: "Loading recent reports…",
    noRecentAiReports: "No recent AI reports found.",
    backToDashboard: "Back to dashboard",
    reportsBreadcrumb: "Reports",
    customizeTable: "Customize table",
    customization: "Customization",
    recordsPerPage: "Records per page",
    visibleColumns: "Visible columns",
    restoreDefault: "Restore default",
    apply: "Apply",
    reportId: "Report ID",
    viewReport: "View report",
    noLandSuitabilityReportsFound: "No Land Suitability reports found.",
    confirmDeleteLandSuitabilityReport: "Are you sure you want to delete this Land Suitability report?",
    landSuitabilityReportDeletedSuccessfully: "Land Suitability report deleted successfully.",
    unableToDeleteReport: "Unable to delete the report.",
    unableToDeleteReportRetry: "Unable to delete the report. Please try again.",
    of: "of",
    estimatedComputeCost: "Estimated Compute Cost",
    totalCreditsRequired: "Total Credits Required",
    creditsAvailable: "Credits Available",
    status: "Status",
    credits: "Credits",
    creditsSufficient: "Credits Sufficient for AI Report Generation",
    insufficientCredits: "Insufficient Credits",
    selectFarm: "Select Farm",
    showAdvanced: "Show advanced",
    sourceFarmZone: "Bedrijf / zone",
    sourcePolygon: "Polygoon",
    sourceCircle: "Cirkel",
    sourceGeojson: "GeoJSON",
    radiusM: "Straal (m)",
    drawPolygon: "Polygoon tekenen",
    drawPolygonHelp: "Klik op de kaart om punten toe te voegen.",
    drawCircle: "Cirkel tekenen",
    drawCircleHelp: "Klik op de kaart om het middelpunt te zetten; stel de straal hieronder in of sleep de cirkel om te vergroten/verkleinen.",
    drawingHintPoint: "Click the map to place a point. Drag the marker to adjust it.",
    drawingHintGeofence: "Click at least three locations to draw the geofence. Drag points to adjust it.",
    drawingHintPointShort: "Click the map to place or move the point",
    drawingHintGeofenceShort: "Click at least three locations to draw the farm boundary",
    undoLastGeofencePoint: "Undo last geofence point",
    undoLastPoint: "Undo last point",
    clearGeofence: "Clear geofence",
    previousImage: "Previous image",
    nextImage: "Next image",
    selectDate: "Select Date",
    reportDetails: "Report Details",
    greenAreas: "Green Areas",
    yellowAreas: "Yellow Areas",
    redAreas: "Red Areas",
    greenAreasDescription: "Current vegetation vigor outperforms historical average",
    yellowAreasDescription: "Current vegetation vigor performs according to historical average",
    redAreasDescription: "Areas with poor crop performance that require immediate attention",
    underperforming: "Underperforming",
    outperforming: "Outperforming",
    landSuitabilityDisclaimer: "This AI-generated report is intended to serve as a guide. For accurate diagnosis and tailored recommendations, consult a qualified agronomist or agricultural expert.",
    startDate: "Start Date",
    numberOfHistoricalReports: "Number of Historical Reports",
    compareReports: "Compare reports",
    satelliteImageryNote: "Satellite imagery for the exact report date may not be available. The closest available satellite layer is shown instead.",
    farmLocation: "Farm location",
    feedback: "Feedback",
    feedbackColon: "Feedback:",
    agreedWithPrediction: "Agreed with Prediction",
    predictionNotAccurate: "Prediction Not Accurate",
    attachments: "Attachments",
    noAttachmentsAdded: "No attachments added",
    doYouAgreeWithPrediction: "Do you agree with the prediction?",
    agree: "Agree",
    disagree: "Disagree",
    agreeWithPrediction: "Agree with prediction",
    disagreeWithPrediction: "Disagree with prediction",
    feedbackDisagreementPlaceholder: "Tell us what does not reflect the current reality of the field",
    addAttachments: "Add attachments",
    removeAttachment: "Remove attachment",
    submitFeedback: "Submit feedback",
    loadingFeedback: "Loading feedback",
    attachment: "Attachment",
    unableToLoadAvailableCrops: "Unable to load available crops.",
    unableToGenerateReport: "Unable to generate the report.",
    unableToLoadLandSuitabilityReport: "Unable to load the Land Suitability report.",
    unableToDownloadReport: "Unable to download the report.",
    pleaseSelectValidGeojson: "Please select a valid Polygon or MultiPolygon GeoJSON file.",
    historicalComparisonUnavailable: "Historical comparison is not available from the current report API.",
    unableToLoadFeedback: "Unable to load feedback.",
    unableToLoadReportFeedback: "Unable to load report feedback.",
    attachmentTypeSizeLimit: "Attachments must be images or videos no larger than 10 MB.",
    unableToSubmitFeedback: "Unable to submit feedback.",
    feedbackSubmittedSuccessfully: "Feedback submitted successfully.",
    unableToSubmitFeedbackRetry: "Unable to submit feedback. Please try again.",
    openReportToViewGuide: "Open a report to view the complete AI report guide.",
    downloadReport: "Download report",
    pleaseSelectPointOnMap: "Please select a point on the map",
    pleaseDrawPolygonMinPoints: "Please draw a polygon with at least 3 points",
    // ---- Farm Productivity / Productivity Zones Analysis ----
    farmProductivity: {
      title: "Analyse van landbouwproductiviteit",
      listOfReports: "Lijst van rapporten",
      createNewReport: "Nieuw rapport maken",
      backToDashboard: "Terug naar dashboard",
      generateReport: "Rapport genereren",
      cancel: "Annuleren",
      back: "Terug",
      deleteReport: "Rapport verwijderen",
      downloadReport: "Rapport downloaden",
      aiReportGuide: "AI-rapportgids",
      viewGuide: "Gids bekijken",
      howToUseReport: "Hoe gebruikt u het rapport?",
      search: "Zoeken",
      reportId: "Rapport-ID",
      farmAndFarmId: "Bedrijf & bedrijfs-ID",
      producerName: "Naam producent",
      dateOfReport: "Datum van rapport",
      status: "Status",
      statusCompleted: "Voltooid",
      statusGenerating: "Bezig met genereren",
      statusFailed: "Mislukt",
      location: "Locatie",
      farm: "Bedrijf",
      zone: "Zone",
      actions: "Acties",
      view: "Bekijken",
      delete: "Verwijderen",
      selectFarmGeofence: "Selecteer boerderij-geofence",
      selectFarmGeofenceHelp: "Selecteer een geregistreerde boerderij, teken de grens op de kaart of upload een GeoJSON-bestand.",
      selectFarmZone: "Selecteer boerderij / zone",
      sourceFarmZone: "Bedrijf / zone",
      sourcePolygon: "Polygoon",
      sourceCircle: "Cirkel",
      sourceGeojson: "GeoJSON",
      radiusM: "Straal (m)",
      select: "Selecteren",
      uploadGeojsonFile: "GeoJSON-bestand uploaden",
      uploadGeojsonHelp: "Selecteer een GeoJSON-bestand met uw geofence en upload het. Er wordt slechts Ã©Ã©n geofence tegelijk geÃ¼pload, ook als het bestand er meerdere bevat.",
      selectAFile: "Selecteer een bestand",
      drawPolygon: "Polygoon tekenen",
      drawPolygonHelp: "Klik op de kaart om punten toe te voegen.",
      drawCircle: "Cirkel tekenen",
      drawCircleHelp: "Klik op de kaart om het middelpunt te zetten; stel de straal hieronder in of sleep de cirkel om te vergroten/verkleinen.",
      estimatedComputeCost: "Geschatte rekenkosten",
      totalCreditsRequired: "Totaal benodigde credits",
      creditsComingSoon: "Creditsysteem binnenkort beschikbaar.",
      reportDetails: "Rapportdetails",
      generating: "Rapport genereren...",
      generatingHelp: "Uw rapport wordt gegenereerd. Dit kan enkele minuten duren.",
      failed: "Rapportgeneratie mislukt.",
      reportDescription: "Het productiviteitszones-rapport analyseert de productiviteit van uw boerderijgebied op basis van historische prestaties en vegetatie-indicatoren.",
      disclaimerTitle: "DISCLAIMER",
      disclaimer: "Dit door AI gegenereerde rapport is bedoeld als richtlijn. Voor een accurate diagnose en passende aanbevelingen raden we sterk aan een gekwalificeerde agronoom of landbouwexpert te raadplegen.",
      zoneLabels: {
        "Lowest Productivity Zones": "Zones met laagste productiviteit",
        "Low Productivity Zones": "Zones met lage productiviteit",
        "Moderate Productivity Zones": "Zones met matige productiviteit",
        "High Productivity Zones": "Zones met hoge productiviteit",
        "Highest Productivity Zones": "Zones met hoogste productiviteit",
      },
      zoneDesc: {
        "Lowest Productivity Zones": "Gebieden met de slechtste gewasprestaties die onmiddellijke aandacht of interventie vereisen.",
        "Low Productivity Zones": "Gebieden met ondergemiddelde gewasprestaties die verbetering nodig hebben.",
        "Moderate Productivity Zones": "Gebieden met matige gewasprestaties die mogelijk enige aanpassingen nodig hebben.",
        "High Productivity Zones": "Gebieden met bovengemiddelde gewasprestaties en goed opbrengstpotentieel.",
        "Highest Productivity Zones": "Gebieden met optimale gewasprestaties en het hoogste opbrengstpotentieel.",
      },
      feedback: "Feedback",
      doYouAgree: "Bent u het eens met de voorspelling?",
      agree: "Eens",
      disagree: "Oneens",
      agreedWithPrediction: "Akkoord met voorspelling",
      disagreedWithPrediction: "Niet akkoord met voorspelling",
      disagreeHelp: "Als u het niet eens bent met dit resultaat, geef dan feedback",
      addFeedback: "Feedback toevoegen",
      feedbackPlaceholder: "Voer hier in",
      attachmentsOptional: "Bijlagen (optioneel)",
      attachments: "Bijlagen",
      download: "Downloaden",
      attachmentsHelp: "Sleep afbeeldingen of video's hierheen, of blader door bestanden. Ondersteunde formaten: JPG, PNG, MP4.",
      selectFilesToUpload: "Selecteer bestanden om gegevens te uploaden",
      orDragAndDrop: "of sleep hierheen",
      submit: "Verzenden",
      feedbackSubmitted: "Feedback succesvol verzonden.",
      feedbackAlreadySubmitted: "Er is al feedback verzonden voor dit rapport.",
      guideTitle: "Gids productiviteitszones",
      guideStep: "Stap {current} van {total}",
      next: "Volgende",
      close: "Sluiten",
      guideStep1Title: "Wat is het productiviteitszones-rapport?",
      guideStep1Body: "Het productiviteitszones-rapport analyseert de productiviteit van gebieden binnen uw zone of boerderij en classificeert ze in zones met lage, gemiddelde en hoge opbrengst.",
      guideStep2Title: "Hoe genereert u een rapport?",
      guideStep2Body: "Een rapport maken is eenvoudig:\n\n1. Selecteer uw boerderij in het dropdownmenu (indien geregistreerd) of teken/upload de grens.\n2. Genereer het rapport en wacht tot de analyse is voltooid.",
      guideStep3Title: "Hoe interpreteert u het rapport?",
      guideStep3Body: "Na generatie toont het rapport een kleurgecodeerde kaart die uw boerderij in drie productiviteitszones verdeelt.",
      guideTip: "Tip:",
      guideTipBody: "Begin met oranje zones — die hebben de meest urgente verbeteringen nodig. Bestudeer groene zones om goede praktijken te herhalen.",
      invalidGeojsonFile: "Ongeldig GeoJSON-bestand",
      invalidGeojsonFileDescription: "Het geselecteerde bestand is geen geldige GeoJSON. Controleer en probeer opnieuw.",
      generateFailed: "Rapportgeneratie kon niet starten. Probeer opnieuw.",
      loadFailed: "Rapport kon niet worden geladen. Probeer opnieuw.",
      deleteConfirmTitle: "Rapport verwijderen",
      deleteConfirmMessage: "Weet u zeker dat u dit rapport wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      deleted: "Rapport succesvol verwijderd.",
      uploadFailed: "Bestandsupload mislukt. Probeer opnieuw.",
    },

    // ---- Anomaly Detection ----
    anomalyDetection: {
      title: "Anomaliedetectie",
      reportComparison: "Rapportvergelijking",
      listOfReports: "Lijst van rapporten",
      createNewReport: "Nieuw rapport maken",
      backToDashboard: "Terug naar dashboard",
      generateReport: "Rapport genereren",
      cancel: "Annuleren",
      back: "Terug",
      deleteReport: "Rapport verwijderen",
      downloadReport: "Rapport downloaden",
      compareReports: "Rapporten vergelijken",
      aiReportGuide: "AI-rapportgids",
      search: "Zoeken",
      reportId: "Rapport-ID",
      farmAndFarmId: "Bedrijf & bedrijfs-ID",
      producerName: "Naam producent",
      dateOfReport: "Datum van rapport",
      status: "Status",
      statusCompleted: "Voltooid",
      statusGenerating: "Bezig met genereren",
      statusPartial: "Gedeeltelijk",
      statusFailed: "Mislukt",
      location: "Locatie",
      farm: "Bedrijf",
      zone: "Zone",
      actions: "Acties",
      view: "Bekijken",
      delete: "Verwijderen",
      selectFarmGeofence: "Selecteer boerderij-geofence",
      selectFarmGeofenceHelp: "Selecteer een geregistreerde boerderij, teken de grens op de kaart of upload een GeoJSON-bestand.",
      selectFarmZone: "Selecteer boerderij / zone",
      sourceFarmZone: "Bedrijf / zone",
      sourcePolygon: "Polygoon",
      sourceCircle: "Cirkel",
      sourceGeojson: "GeoJSON",
      radiusM: "Straal (m)",
      select: "Selecteren",
      uploadGeojsonFile: "GeoJSON-bestand uploaden",
      uploadGeojsonHelp: "Selecteer een GeoJSON-bestand met uw geofence en upload het. Er wordt slechts Ã©Ã©n geofence tegelijk geÃ¼pload, ook als het bestand er meerdere bevat.",
      selectAFile: "Selecteer een bestand",
      drawPolygon: "Polygoon tekenen",
      drawPolygonHelp: "Klik op de kaart om punten toe te voegen.",
      drawCircle: "Cirkel tekenen",
      drawCircleHelp: "Klik op de kaart om het middelpunt te zetten; stel de straal hieronder in of sleep de cirkel om te vergroten/verkleinen.",
      detectAnomalies: "Anomalieën detecteren",
      detectAnomaliesHelp: "Na het tekenen of uploaden van een geofence, selecteer de gewenste datum om anomalieën te detecteren.",
      startDate: "Startdatum",
      fetchingDates: "Beschikbare datums ophalen...",
      noAvailableDates: "Er zijn geen satellietdatums beschikbaar voor dit gebied.",
      selectDateToGenerate: "Selecteer een beschikbare datum en genereer daarna het rapport.",
      numberOfHistoricalReports: "Aantal historische rapporten",
      historicalReportsPlaceholder: "Voer hier in",
      historicalReportsNote: "Het verhogen van dit aantal verbruikt extra AI-credits voor elke gevraagde historische afbeelding.",
      estimatedComputeCost: "Geschatte rekenkosten",
      totalCreditsRequired: "Totaal benodigde credits",
      creditsComingSoon: "Creditsysteem binnenkort beschikbaar.",
      selectDate: "Selecteer datum",
      reportDetails: "Rapportdetails",
      closestImageNote: "Satellietbeelden voor {requested} waren niet beschikbaar. We hebben de dichtstbijzijnde beschikbare afbeelding gebruikt.",
      generating: "Rapport genereren...",
      generatingHelp: "Uw rapport wordt gegenereerd. Dit kan enkele minuten duren.",
      partialWarning: "Sommige datums konden niet worden gegenereerd voor dit rapport.",
      failed: "Rapportgeneratie mislukt.",
      disclaimerTitle: "DISCLAIMER",
      disclaimer: "Dit door AI gegenereerde rapport is bedoeld als richtlijn. Voor een accurate diagnose en passende aanbevelingen raden we sterk aan een gekwalificeerde agronoom of landbouwexpert te raadplegen.",
      greenAreas: "Groene gebieden",
      greenAreasDesc: "Huidige vegetatievitaliteit presteert beter dan het historische gemiddelde",
      yellowAreas: "Gele gebieden",
      yellowAreasDesc: "Huidige vegetatievitaliteit presteert volgens het historische gemiddelde",
      redAreas: "Rode gebieden",
      redAreasDesc: "Gebieden met slechte gewasprestaties die onmiddellijke aandacht of interventie vereisen.",
      underperforming: "Onderpresterend",
      outperforming: "Overpresterend",
      imageComparison: "Rapportvergelijking",
      sideComparison: "Zij-aan-zij vergelijking",
      sliderComparison: "Schuifvergelijking",
      transparencyComparison: "Transparantievergelijking",
      transparencySlider: "Transparantieschuif",
      notGeneratedPrompt: "Dit rapport is nog niet gegenereerd voor de geselecteerde datum. Nu genereren?",
      generateNow: "Nu genereren",
      feedback: "Feedback",
      doYouAgree: "Bent u het eens met de voorspelling?",
      agree: "Eens",
      disagree: "Oneens",
      agreedWithPrediction: "Akkoord met voorspelling",
      disagreedWithPrediction: "Niet akkoord met voorspelling",
      disagreeHelp: "Als u het niet eens bent met dit resultaat, geef dan feedback",
      addFeedback: "Feedback toevoegen",
      feedbackPlaceholder: "Voer hier in",
      attachmentsOptional: "Bijlagen (optioneel)",
      attachments: "Bijlagen",
      download: "Downloaden",
      attachmentsHelp: "Sleep afbeeldingen of video's hierheen, of blader door bestanden. Ondersteunde formaten: JPG, PNG, MP4.",
      selectFilesToUpload: "Selecteer bestanden om gegevens te uploaden",
      orDragAndDrop: "of sleep hierheen",
      submit: "Verzenden",
      feedbackSubmitted: "Feedback succesvol verzonden.",
      feedbackAlreadySubmitted: "Er is al feedback verzonden voor dit rapport.",
      guideTitle: "Gids anomaliedetectie",
      guideStep: "Stap {current} van {total}",
      next: "Volgende",
      close: "Sluiten",
      guideStep1Title: "Wat is anomaliedetectie?",
      guideStep1Body: "Anomaliedetectie vergelijkt de huidige vegetatieprestaties van uw veld met het historische gemiddelde om gebieden te identificeren die beter of slechter presteren dan verwacht.",
      guideStep2Title: "Hoe genereert u een rapport?",
      guideStep2Body: "Een rapport maken is eenvoudig:\n\n1. Selecteer uw boerderij in het dropdownmenu (indien al geregistreerd) of teken/upload de grens.\n2. Kies een beschikbare datum en genereer het rapport.",
      guideStep3Title: "Hoe interpreteert u het rapport?",
      guideStep3Body: "Na generatie toont het rapport een kleurgecodeerde heatmap van uw boerderij op basis van hoe de huidige vitaliteit zich verhoudt tot de historie.",
      guideTip: "Tip:",
      guideTipBody: "Datumvergelijking: het rapport biedt heatmaps voor meerdere datums, zodat u veranderingen in de tijd kunt volgen.",
      invalidGeojsonFile: "Ongeldig GeoJSON-bestand",
      invalidGeojsonFileDescription: "Het geselecteerde bestand is geen geldige GeoJSON. Controleer en probeer opnieuw.",
      geofenceRequired: "Selecteer een boerderij/zone, teken een geofence of upload een GeoJSON.",
      dateRequired: "Selecteer een beschikbare datum.",
      generateFailed: "Rapportgeneratie kon niet starten. Probeer opnieuw.",
      loadFailed: "Rapport kon niet worden geladen. Probeer opnieuw.",
      datesFailed: "Kon beschikbare datums niet ophalen. Probeer het opnieuw.",
      deleteConfirmTitle: "Rapport verwijderen",
      deleteConfirmMessage: "Weet u zeker dat u dit rapport wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      deleted: "Rapport succesvol verwijderd.",
      uploadFailed: "Bestandsupload mislukt. Probeer opnieuw.",
    },

        yieldPredictionDesign: {
      disclaimerTitle: "DISCLAIMER",
      disclaimerIntro: "In our yield predictions, the uncertainty may be 100% because there are many factors that are beyond our control, including:",
      disclaimer1: "It is impossible to accurately predict the weather for a whole season, so in some cases farmers could lose all their harvest due to just one hail event or flooding (especially now that global warming is often causing all these irregularities).",
      disclaimer2: "Yields are highly dependent on the management practices of farmers. For example, if they fail to spray pesticides at the right time, or irrigate properly, then yields will be very different from the predictions - this is also beyond our control.",
      disclaimer3: "There are many other factors like the above that may contribute to significant errors in the AI yield predictions.",
      disclaimer4: "If the farmer provides historical yields (ADVANCED mode), then predictions tend to be more accurate than the default (non-ADVANCED mode) predictions.",
      // feedback (shared FeedbackDisplay / FeedbackDialog)

      feedback: "Feedback",
      doYouAgree: "Bent u het eens met de voorspelling?",
      agree: "Eens",
      disagree: "Oneens",
      agreedWithPrediction: "Akkoord met voorspelling",
      disagreedWithPrediction: "Niet akkoord met voorspelling",
      disagreeHelp: "Als u het niet eens bent met dit resultaat, geef dan feedback",
      addFeedback: "Feedback toevoegen",
      feedbackPlaceholder: "Voer hier in",
      attachmentsOptional: "Bijlagen (optioneel)",
      attachments: "Bijlagen",
      download: "Downloaden",
      attachmentsHelp: "Sleep afbeeldingen of video's hierheen, of blader door bestanden. Ondersteunde formaten: JPG, PNG, MP4.",
      selectFilesToUpload: "Selecteer bestanden om gegevens te uploaden",
      orDragAndDrop: "of sleep hierheen",
      submit: "Verzenden",
      feedbackSubmitted: "Feedback succesvol verzonden.",
      feedbackAlreadySubmitted: "Er is al feedback verzonden voor dit rapport.",
      uploadFailed: "Bestandsupload mislukt. Probeer opnieuw.",
    },

landSuitabilityDesign: {
      reportDetails: "Rapportdetails",
      greenAreas: "Groene gebieden",
      greenAreasDesc: "Gebieden die als zeer geschikt zijn beoordeeld voor het geselecteerde gewas",
      yellowAreas: "Gele gebieden",
      yellowAreasDesc: "Gebieden met matige geschiktheid die aandacht kunnen vereisen",
      redAreas: "Rode gebieden",
      redAreasDesc: "Gebieden die als ongeschikt zijn beoordeeld en waarschijnlijk interventie nodig hebben",
      underperforming: "Onderpresterend",
      outperforming: "Overpresterend",
      feedback: "Feedback",
      doYouAgree: "Bent u het eens met de voorspelling?",
      agree: "Eens",
      disagree: "Oneens",
      agreedWithPrediction: "Akkoord met voorspelling",
      disagreedWithPrediction: "Niet akkoord met voorspelling",
      disagreeHelp: "Als u het niet eens bent met dit resultaat, geef dan feedback",
      addFeedback: "Feedback toevoegen",
      feedbackPlaceholder: "Voer hier in",
      attachmentsOptional: "Bijlagen (optioneel)",
      attachments: "Bijlagen",
      download: "Downloaden",
      attachmentsHelp: "Sleep afbeeldingen of video's hierheen, of blader door bestanden. Ondersteunde formaten: JPG, PNG, MP4.",
      selectFilesToUpload: "Selecteer bestanden om gegevens te uploaden",
      orDragAndDrop: "of sleep hierheen",
      submit: "Verzenden",
      feedbackSubmitted: "Feedback succesvol verzonden.",
      feedbackAlreadySubmitted: "Er is al feedback verzonden voor dit rapport.",
      uploadFailed: "Bestandsupload mislukt. Probeer opnieuw.",
    },
    cropProgression: {
      title: "Analyse van vegetatievitaliteit",
      listOfReports: "Lijst van rapporten",
      createNewReport: "Nieuw rapport maken",
      backToDashboard: "Terug naar dashboard",
      generateReport: "Rapport genereren",
      cancel: "Annuleren",
      back: "Terug",
      deleteReport: "Rapport verwijderen",
      downloadReport: "Rapport downloaden",
      compareImages: "Afbeeldingen vergelijken",
      aiReportGuide: "AI-rapportgids",
      search: "Zoeken",
      reportId: "Rapport-ID",
      farmAndFarmId: "Bedrijf & bedrijfs-ID",
      producerName: "Naam producent",
      dateOfReport: "Datum van rapport",
      selectedDate: "Rapportdatum",
      status: "Status",
      statusCompleted: "Voltooid",
      statusGenerating: "Bezig met genereren",
      statusPartial: "Gedeeltelijk",
      statusFailed: "Mislukt",
      location: "Locatie",
      farm: "Bedrijf",
      zone: "Zone",
      actions: "Acties",
      view: "Bekijken",
      delete: "Verwijderen",
      selectFarmGeofence: "Selecteer bedrijfsgeofence",
      selectFarmGeofenceHelp: "Selecteer een geregistreerd bedrijf, teken de grens op de kaart of upload een GeoJSON om uw gebied te analyseren.",
      point: "Punt",
      geofence: "Geofence",
      selectFarmZone: "Selecteer bedrijf / zone",
      sourceFarmZone: "Bedrijf / zone",
      sourcePolygon: "Polygoon",
      sourceCircle: "Cirkel",
      sourceGeojson: "GeoJSON",
      mapView: "Kaartweergave",
      latitude: "Breedtegraad",
      longitude: "Lengtegraad",
      radiusKm: "Straal (km)",
      radiusM: "Straal (m)",
      enterHere: "Voer hier in",
      select: "Selecteren",
      uploadGeojsonFile: "GeoJSON-bestand uploaden",
      uploadGeojsonHelp: "Selecteer een GeoJSON-bestand met uw geofence en upload het. Er wordt slechts één geofence tegelijk geüpload, ook als het bestand er meerdere bevat.",
      selectAFile: "Selecteer een bestand",
      drawPolygon: "Polygoon tekenen",
      drawPolygonHelp: "Klik op de kaart om punten toe te voegen.",
      drawCircle: "Cirkel tekenen",
      drawCircleHelp: "Klik op de kaart om het middelpunt te zetten; stel de straal hieronder in of sleep de cirkel om te vergroten/verkleinen.",
      clearDrawing: "Wissen",
      searchLocation: "Locatie zoeken",
      closePolygonHint: "Klik op het eerste punt om het gebied te sluiten",
      unnamedFarm: "Boerderij #{id}",
      unnamedZone: "Zone #{id}",
      selectDate: "Selecteer datum",
      availableDates: "Beschikbare datums",
      fetchingDates: "Beschikbare datums ophalen...",
      noAvailableDates: "Er zijn geen satellietdatums beschikbaar voor dit gebied.",
      selectDateToGenerate: "Selecteer een beschikbare datum en genereer daarna het rapport.",
      estimatedComputeCost: "Geschatte rekenkost",
      totalCreditsRequired: "Totaal vereiste credits",
      creditsAvailable: "Beschikbare credits",
      creditsSufficient: "Voldoende credits voor AI-rapportgeneratie",
      reportType: "Rapporttype",
      selectReportType: "Selecteer rapporttype",
      chooseIndexHelp: "Kies een satellietindex om gewasgroei, vocht of nutriënten in de tijd te analyseren.",
      scale: "Schaal",
      generating: "Rapport genereren...",
      generatingHelp: "Uw rapport wordt gegenereerd. Dit kan enkele minuten duren.",
      partialWarning: "Sommige indices konden niet worden gegenereerd voor deze datum.",
      failed: "Rapportgeneratie mislukt.",
      valuesCloseToOne: "Waarden dicht bij 1 duiden op gezondere vegetatie",
      disclaimerTitle: "DISCLAIMER",
      disclaimer: "Dit door AI gegenereerde rapport is bedoeld als richtlijn. Voor een accurate diagnose en passende aanbevelingen raden we sterk aan een gekwalificeerde agronoom of landbouwexpert te raadplegen.",
      indexNDVI: "Gewasgezondheid (NDVI)",
      indexMSAVI: "Vroege vegetatiegroei (MSAVI)",
      indexLSWI: "Vochtgehalte (LSWI)",
      indexRECI: "Schatting nutriëntenniveau (RECI)",
      indexNDRE: "Groenheid & bladerdakdichtheid (NDRE)",
      reportComparison: "Vergelijking vegetatievitaliteitsrapporten",
      imageComparison: "Afbeeldingsvergelijking",
      sideComparison: "Zij-aan-zij vergelijking",
      sliderComparison: "Schuifvergelijking",
      transparencyComparison: "Transparantievergelijking",
      transparencySlider: "Transparantieschuif",
      notGeneratedPrompt: "Dit rapport is nog niet gegenereerd voor de geselecteerde datum. Nu genereren?",
      generateNow: "Nu genereren",
      feedback: "Feedback",
      doYouAgree: "Bent u het eens met de voorspelling?",
      agree: "Eens",
      disagree: "Oneens",
      agreedWithPrediction: "Akkoord met voorspelling",
      disagreedWithPrediction: "Niet akkoord met voorspelling",
      disagreeHelp: "Als u het niet eens bent met dit resultaat, geef dan uw feedback",
      addFeedback: "Feedback toevoegen",
      feedbackPlaceholder: "Voer hier in",
      attachmentsOptional: "Bijlagen (optioneel)",
      attachments: "Bijlagen",
      download: "Downloaden",
      attachmentsHelp: "Sleep afbeeldingen of video's hierheen, of blader door bestanden. Ondersteunde formaten: JPG, PNG, MP4.",
      selectFilesToUpload: "Selecteer bestanden om gegevens te uploaden",
      orDragAndDrop: "of sleep hierheen",
      submit: "Verzenden",
      feedbackSubmitted: "Feedback succesvol verzonden.",
      feedbackAlreadySubmitted: "Er is al feedback verzonden voor dit rapport.",
      guideTitle: "Gids voor analyse van vegetatievitaliteit",
      guideStep: "Stap {current} van {total}",
      next: "Volgende",
      close: "Sluiten",
      guideStep1Title: "Wat is een vegetatievitaliteitsrapport?",
      guideStep1Body: "Deze analyse helpt u gebieden met lage vegetatievitaliteit te vinden zodat u tijdig kunt handelen. Het rapport gebruikt satellietbeelden om te tonen hoe gezond uw gewassen op een bepaald moment zijn.\n\nDe heatmap toont welke delen van uw bedrijf aandacht nodig hebben. Door beelden van verschillende data te vergelijken, volgt u of gewassen verbeteren of achteruitgaan.",
      guideStep2Title: "Hoe genereert u een rapport?",
      guideStep2Body: "Een rapport maken is eenvoudig:\n\n1. Selecteer uw bedrijf in het dropdownmenu (als het al geregistreerd is). De grens verschijnt op de kaart. Of teken de grens handmatig als die nog niet geregistreerd is.\n2. Kies een datum: de datum waarvoor u vitaliteitsgegevens wilt zien.\n3. Klik op \"Rapport genereren\" om uw analyse te bekijken.",
      guideStep3Title: "Hoe interpreteert u het rapport?",
      guideStep3Body: "Na generatie ziet u een heatmap van uw bedrijf met groen, geel en rood.\n\nGroen = Hoge vegetatievitaliteit\nGeel/Rood = Lagere vitaliteit → mogelijk aandacht nodig\n\nLage vitaliteit kan komen door oogst, arme grond, plagen of recent weer.",
      guideTip: "Tip:",
      guideTipBody: "Gebruik de datumwisselaar onder de heatmap om meerdere rapporten te bekijken en veranderingen in gewasgezondheid te volgen. U kunt rapporten altijd opslaan, downloaden of verwijderen.",
      additionalReportTypes: "Extra beschikbare rapporttypes:",
      invalidGeojsonFile: "Ongeldig GeoJSON-bestand",
      invalidGeojsonFileDescription: "Het geselecteerde bestand is geen geldige GeoJSON. Controleer en probeer opnieuw.",
      geofenceRequired: "Selecteer een bedrijf/zone, teken een geofence of upload een GeoJSON.",
      dateRequired: "Selecteer een beschikbare datum.",
      generateFailed: "Rapportgeneratie kon niet starten. Probeer opnieuw.",
      loadFailed: "Rapport kon niet worden geladen. Probeer opnieuw.",
      datesFailed: "Beschikbare datums konden niet worden opgehaald. Probeer opnieuw.",
      deleteConfirmTitle: "Rapport verwijderen",
      deleteConfirmMessage: "Weet u zeker dat u dit rapport wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      deleted: "Rapport succesvol verwijderd.",
      uploadFailed: "Bestandsupload mislukt. Probeer opnieuw.",
    },
    aiClient: {
      credits: "Credits",
      cancel: "Annuleren",
      save: "Opslaan",
      back: "Terug",
      close: "Sluiten",
      search: "Zoeken",
      makeSelection: "Maak een selectie",
      errorTitle: "Fout",
      successTitle: "Gelukt",
      loadFailed: "Gegevens konden niet worden geladen. Probeer het opnieuw.",
      saveFailed: "Opslaan is mislukt. Probeer het opnieuw.",
      saved: "Instellingen succesvol opgeslagen.",
      rt_vegetation_vigor: "Vegetatievitaliteit",
      rt_farm_productivity: "Bedrijfsproductiviteit",
      rt_anomaly_detection: "Anomaliedetectie",
      rt_yield_prediction: "Opbrengstvoorspelling",
      rt_disease_detection: "Ziektedetectie",
      rt_land_suitability: "Geschiktheid van land",
      dashTitle: "AI-rapportagedashboard",
      dashGuide: "Dashboardgids",
      builders: "AI-rapportgenerators",
      distributionTitle: "Verdeling per rapporttype",
      colReportType: "Rapporttype",
      colReportsGenerated: "Gegenereerde rapporten",
      recentTitle: "Recente AI-rapporten",
      noRecent: "Er zijn nog geen rapporten gegenereerd.",
      noDistribution: "Nog geen rapportactiviteit.",
      na: "N.v.t.",
      bVegetationVigor: "Analyse van vegetatievitaliteit",
      bFarmProductivity: "Analyse van bedrijfsproductiviteit",
      bAnomalies: "Anomaliedetectie",
      bYield: "Opbrengstvoorspelling",
      bDisease: "Ziektedetectie",
      bLand: "Geschiktheid van land",
      insightsTitle: "AI-inzichten en analyses",
      iVegHealth: "Gemiddelde vegetatiegezondheid",
      iDisease: "Ziekten gedetecteerd deze maand",
      iAnomalies: "Anomalieën deze maand",
      iYieldTrend: "Voorspelde opbrengsttrend",
      creditsAvailableLabel: "Beschikbaar",
      totalCredits: "Totale credits:",
      creditsUsedLabel: "Gebruikte credits:",
      topUp: "Credits opwaarderen",
      topUpInfo: "Neem contact op met uw beheerder om credits op te waarderen.",
      creditsHistory: "Credithistorie",
      manageBtn: "AI-rapportage en credits beheren",
      manageTitle: "AI-rapportage en credits beheren",
      usageLogBtn: "Gebruikslogboek credits",
      cardAvailable: "Beschikbare credits",
      cardTotal: "Totale credits",
      cardUsed: "Gebruikte credits",
      refreshesOn: "Vernieuwt op",
      assignedOn: "Toegewezen op",
      distBudgetTitle: "Verdeling en budgettering van AI-rapporten",
      distBudgetHelp: "Configureer AI-rapportagetoegang voor uw unies, fabrieken en boeren. Wijs specifieke creditbudgetten toe aan elk niveau om het resourceverbruik van uw coöperatie efficiënt te beheren.",
      group_cooperative: "Coöperatie",
      group_buying_station: "Inkoopstation",
      group_farmer: "Boer",
      monthlyCredits: "Maandelijkse credits",
      aiReports: "AI-rapporten",
      enabled: "Ingeschakeld",
      disabled: "Uitgeschakeld",
      overAllocation: "Groepstoewijzingen overschrijden het creditbudget van de coöperatie.",
      usageLogTitle: "Gebruikslogboek credits",
      filterCooperative: "Coöperatie",
      filterReport: "AI-rapport",
      colDateTime: "Datum en tijd",
      colEntity: "Entiteit",
      colAiReport: "AI-rapport",
      colCreditsUsed: "Gebruikte credits",
      colBalance: "Saldo",
      historyTitle: "Credithistorie",
      historyDesc: "Een overzicht van credittoewijzingen versus verbruik voor deze coöperatie. Gebruik dit overzicht om maandelijkse gebruikstrends en factureringscycli te volgen.",
      coopLabel: "Coöperatie",
      colMonth: "Maand",
      colCreditsAssigned: "Toegewezen credits",
      colClosingBalance: "Eindsaldo",
      noHistory: "Nog geen credithistorie.",
      guideTitle: "Gids voor het Dimitra AI-rapportagedashboard",
      guideStep: "Stap",
      guideOf: "van",
      guideClose: "Sluiten",
      guideSkip: "Overslaan",
      guideNext: "Volgende",
      guideBack: "Terug",
      guideDone: "Sluiten",
      g1Title: "Dashboardoverzicht",
      g1Intro: "Welkom bij uw AI-inzichtencentrum. Deze gids helpt u de kaart te interpreteren, uw credits te beheren en de AI-modellen te gebruiken.",
      g1Points: [
        "Kaartinzichten begrijpen: Gebruik de filters op de kaart om specifieke provincies en regio's te bekijken. De heatmap geeft een directe kleurgecodeerde weergave van bedrijfsprestaties binnen de coöperatie, met sleutels voor Hoge/Middelhoge/Lage indicatoren.",
        "Credits monitoren: Uw huidige beschikbare credits staan rechtsboven. Zorg dat u voldoende saldo heeft voordat u grote rapporten genereert.",
      ],
      g2Title: "AI-rapporten begrijpen",
      g2Intro: "Uw dashboard biedt toegang tot gespecialiseerde AI-modellen. Elk rapport analyseert andere aspecten van uw landbouwgegevens.",
      g2Points: [
        "Vegetatievitaliteit: Beoordeel de algemene gewasgezondheid en identificeer gebieden die aandacht nodig hebben.",
        "Bedrijfsproductiviteit: Analyseer historische productiviteitstrends om het opbrengstpotentieel te optimaliseren.",
        "Anomaliedetectie: Spot onregelmatige veldpatronen die kunnen wijzen op stress of externe bedreigingen.",
        "Opbrengstvoorspelling: Voorspel oogstresultaten op basis van huidige groeigegevens.",
        "Ziektedetectie: Gebruik plantbeelden om specifieke ziekten direct te identificeren.",
      ],
      g3Title: "Hoe credits werken",
      g3Intro: "Dimitra gebruikt een creditgebaseerd systeem om AI-resourceverbruik te beheren. Credits fungeren als valuta voor het genereren van rapporten.",
      g3Points: [
        "Toewijzing: Uw coöperatie krijgt maandelijks een saldo toegewezen door uw beheerder.",
        "Verbruik: Telkens wanneer u een rapport genereert, worden credits afgeschreven van uw beschikbare saldo.",
        "Zichtbaarheid: U kunt elke afschrijving volgen in uw speciale creditboekhouding.",
      ],
      g4Title: "Gebruik en credithistorie monitoren",
      g4Intro: "Blijf grip houden op uw budget door uw credithistorie nauwlettend te volgen.",
      g4Points: [
        "Beschikbaar saldo: Altijd zichtbaar in de kaart rechtsboven. Let op de vernieuwingsdatum om te weten wanneer de volgende toewijzing aankomt.",
        "Gebruikslogboek: Klik op [Credithistorie] voor een gedetailleerd overzicht van welk rapport is gegenereerd, wanneer en door welke entiteit (coöperatie, unie, fabriek of boer).",
        "Beheer: Als u weinig credits over heeft, gebruikt u de knop [AI-rapportage en credits beheren] om budgetten per entiteit aan te passen of neemt u contact op met uw beheerder voor een extra snelle opwaardering.",
      ],
    },
  },
};
